<template>
  <v-navigation-drawer
    id="default-drawer"
    v-model="drawer"
    :dark="dark"
    :right="$vuetify.rtl"
    :src="drawerImage ? image : ''"
    :mini-variant.sync="mini"
    mini-variant-width="80"
    app
    width="260"
  >
    <template v-if="drawerImage" #img="props">
      <v-img :key="image" :gradient="gradient" v-bind="props" />
    </template>

    <div class="d-flex flex-column flex-grow-1" style="min-height: 100%;">
      <div class="px-2 flex-grow-0">
        <default-drawer-header />
        <v-divider class="mx-3 mb-2" />
        <default-list :items="items" />
      </div>
      <v-spacer />
      <v-divider class="mx-3" />
      <div class="px-2 pb-2">
        <default-drawer-logout />
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapGetters } from "vuex";
import { get, sync } from "vuex-pathify";

export default {
  name: "DefaultDrawer",

  components: {
    DefaultDrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        "./widgets/DrawerHeader"
      ),
    DefaultList: () =>
      import(
        /* webpackChunkName: "default-list" */
        "./List"
      ),
    DefaultDrawerLogout: () =>
      import(
        /* webpackChunkName: "default-drawer-logout" */
        "./widgets/DrawerLogout"
      )
  },

  computed: {
    ...get("user", ["dark", "gradient", "image"]),
    ...mapGetters("app", ["items"]),
    ...get("app", ["version"]),
    ...sync("app", ["drawer", "drawerImage", "mini"])
  }
};
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
